module.exports = __webpack_public_path__ + "img/logo.69c5cca7.png";